import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-show-substitutes',
    templateUrl: './show-substitutes.component.html',
    styleUrls: ['./show-substitutes.component.scss'],
    standalone: false
})
export class ShowSubstitutesComponent implements OnInit {
  config = {
    "submitButton": false,
    "cancelButton": false,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": ''
  };
  currentData: any = {};
  resourceDef: any = {};
  constructor(
    private baseService: BaseService,
    route: ActivatedRoute,
    private dialogConfig: DialogConfig,
    public alerts: AlertsService,
    public dialog: DialogRef,
    public loader: LoaderService
  ) {
  }
  ngOnInit(): void {
    this.loader.showSpinner();

    if (this.dialogConfig?.data) {
      const rowData = this.dialogConfig.data.data;
      const requiredQty = rowData.requiredQty ?? rowData.reqestedquantity;
      this.resourceDef.form = this.createForm(requiredQty, rowData.itemCode);
    }

    this.loader.hideSpinner();

  }
  questionValueChanged(event) {
    if (!event?.question?.question?._manualChange) return;

    const { substituteItemName, substituteItemCode } = event.form.controls;
    const options = substituteItemName?.question_component?.question?.options || [];

    if (substituteItemName.value && substituteItemCode.value && options.length > 0) {
      const currentSelection = options.find(option => option.itemCode === substituteItemCode.value);
      this.dialog.close(currentSelection || undefined);
      this.removeClassFromBody();
    }
  }
  removeClassFromBody() {
    // Get the body element using getElementsByTagName
    const body = document.getElementsByTagName('body')[0];

    // Check if the body has the class 'modal-open' and remove it
    if (body.classList.contains('modal-open')) {
      body.classList.remove('modal-open');
    }

  }

  createForm(requiredQty, itemCode) {
    return {
      "blocks": [
        {
          "name": "basic_information",
          "order": 1,
          "layout_type": "one-column",
          "fields": [
            {
              "label": "field.label.substitute",
              "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
              "order": 1,
              "type": "String",
              "component": "searchselect",
              "controlType": "searchselect",
              "dependents": [
                {
                  "dependent_field": "substituteItemCode",
                  "value": "itemCode",
                  "action": "populate_field"
                },
                {
                  "dependent_field": "isFormulary",
                  "value": "isFormulary",
                  "action": "populate_field"
                }
              ],
              "defaultsetting": {
                "barcode": true,
                "apliCall": true,
                "defaultOpen": true,
                "checkBoxRequired": false,
                "singleSelection": true,
                "closeDropDownOnSelection": true,
                "allowSearchFilter": true,
                "defaultData": true,
                "flag": true
              },
              "flag": {
                "conditions": [
                  {
                    "expression": "item!=undefined && item.itemFlag!=undefined && item.itemFlag.length!=undefined && item.itemFlag.length && (item.itemFlag.filter((f)=>{return f.id == 'narcotics_drug'})).length>0",
                    "format": "(item)=>{let a='';for(let currentVal of item.itemFlag){a=currentVal.text+','+a} return a.slice(0, -1); }",
                    "class": "grid-high-icon black-narcotics"
                  },
                  {
                    "expression": "item!=undefined && item.itemFlag!=undefined && item.itemFlag.length!=undefined && item.itemFlag.length && (item.itemFlag.filter((f)=>{return f.id == 'lasa'})).length>0",
                    "format": "(item)=>{let a='';for(let currentVal of item.itemFlag){a=currentVal.text+','+a} return a.slice(0, -1); }",
                    "class": "grid-high-icon yellow-lasa"
                  },
                  {
                    "expression": "item!=undefined && item.itemFlag!=undefined && item.itemFlag.length!=undefined && item.itemFlag.length && (item.itemFlag.filter((f)=>{return f.id == 'restricted_antibiotic'})).length>0",
                    "format": "(item)=>{let a='';for(let currentVal of item.itemFlag){a=currentVal.text+','+a} return a.slice(0, -1); }",
                    "class": "grid-high-icon red-antibiotics"
                  },
                  {
                    "expression": "item!=undefined && item.itemFlag!=undefined && item.itemFlag.length!=undefined && item.itemFlag.length && (item.itemFlag.filter((f)=>{return f.id == 'high_risk'})).length>0",
                    "format": "(item)=>{let a='';for(let currentVal of item.itemFlag){a=currentVal.text+','+a} return a.slice(0, -1); }",
                    "class": "grid-high-icon blue-emergency"
                  }
                ]
              },
              "format": "(item) => `${item.itemName} | ${item.itemCode} | Stock:${item.itemQty}`",
              "req_keys": [
                "itemCode",
                "itemName",
                "itemFlag",
                "itemTypeKey",
                "itemQty",
                "unitPrice",
                "batchNo",
                "conversion", "standard_codes", "composition",
                "isFormulary"
              ],
              "datasource": {
                "query_id": "GET_SUBSTITUTE_ITEM",
                "args": `requiredQty:${requiredQty},itemCode:${itemCode}`,
                "resource": "item",
                "application": "inventory-management"
              },
              "name": "substituteItemName",
              "view_key": "substituteItemName",
              "getterValue": "itemName",
              "popover": "composition",
              "required": false,
              "getterKey": "itemName",
            },
            {
              "name": "substituteItemCode",
              "component": "hidden",
              "type": "string",
            },
            {
              "name": "isFormulary",
              "component": "hidden",
              "type": "string"
            }
          ],
        }
      ]
    }
  }
}
